const styles = () => ({
  root: {
    width: '100%', // Full width on mobile
    maxWidth: 1190,
    backgroundColor: '#F4F6F8',
    height: 144,
    padding: '12px 0px', // Combined padding
    borderRadius: 16,    
  },
  buttonContact: {
    width: '100%', // Full width on mobile
    maxWidth: 150,
    height: 40,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    color: '#002E47',
    fontSize: 16,
  },
  typographyContact: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '24px',
    marginBottom: 0,
  },
  typographyContact2: {
    marginRight: 5,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 18,
    height: 22,
    '@media (max-width: 600px)': {
      fontSize: 14,
  },
  },
  typographyContact3: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 16,
    height: 22,
    marginTop: '2px',
    '@media (max-width: 600px)': {
      fontSize: 14,
  },
  },
})

export default styles
